import React from "react"
import { Redirect, withRouter } from "react-router-dom"

const Assistant = (props) => (
    <Redirect to ={{ pathname: "/dashboard/troubleshooter", state: { from: props.location } }}/>
)

export default withRouter(Assistant)